import { Box, Container, Stack } from '@mui/material';
import { Link } from 'react-router';
import styled from 'styled-components';

export const LayoutContainer = styled(Box)`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  justify-content: center;
  background-color: ${({ theme }) =>
    theme.palette?.background?.default || '#F4F5FB'};
  padding: 3rem 1.5rem;

  @media (min-width: 640px) {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  @media (min-width: 1024px) {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`;

export const LogoContainer = styled(Box)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1.25rem;
  }
`;

export const StyledLink = styled(Link)`
  && {
    display: flex;
    align-items: center;
    color: ${({ theme }) => theme.palette?.text?.primary || '#222325'};
    text-decoration: none;

    svg {
      width: 5rem;
      height: 5rem;
    }

    &:hover {
      text-decoration: none;
      opacity: 0.9;
    }
  }
`;

export const ChildrenWrapper = styled(Container)`
  && {
    margin-top: 2rem;

    @media (min-width: 640px) {
      margin-left: auto;
      margin-right: auto;
      width: 100%;
      max-width: 28rem;
    }
  }
`;

export const HeaderContainer = styled(Stack)`
  position: absolute;
  width: 100vw;
`;
